<form class="entity-form" [formGroup]="form" (submit)="handleSubmit()">
  <!-- Name -->
  <mat-form-field class="form-field col100" appFormField>
    <mat-label>Name</mat-label>
    <input matInput type="text" formControlName="name" />
    <mat-error>
      <app-control-errors controlName="name">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- Address -->
  <mat-form-field class="form-field col100" appFormField>
    <mat-label>Address</mat-label>
    <input matInput type="text" formControlName="street_address" />
    <mat-error>
      <app-control-errors controlName="street_address">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- Second Address -->
  <mat-form-field class="form-field col100" appFormField>
    <mat-label>Address Line 2</mat-label>
    <input matInput type="text" formControlName="street_address2" />
    <mat-error>
      <app-control-errors controlName="street_address2">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- City -->
  <mat-form-field class="form-field col100" appFormField>
    <mat-label>City</mat-label>
    <input matInput type="text" formControlName="city" />
    <mat-error>
      <app-control-errors controlName="city">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- Country -->
  <mat-form-field class="form-field col50" appFormField>
    <mat-label>Country</mat-label>
    <mat-select formControlName="country">
      <mat-option
        *ngFor="let country of countries$ | async"
        [value]="country.code"
        >{{ country.name }}</mat-option
      >
    </mat-select>
    <mat-error>
      <app-control-errors controlName="country">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- Province/State -->
  <mat-form-field class="form-field col50" appFormField>
    <mat-label>Region</mat-label>
    <mat-select formControlName="region">
      <mat-option
        *ngFor="let region of regions$ | async"
        [value]="region.code"
        >{{ region.name }}</mat-option
      >
    </mat-select>
    <mat-error>
      <app-control-errors controlName="region">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- Postal Code -->
  <mat-form-field class="form-field col100" appFormField>
    <mat-label>Postal Code</mat-label>
    <input matInput type="text" formControlName="postal_code" />
    <mat-error>
      <app-control-errors controlName="postal_code">
        <ng-template appControlError="api" dynamicMessage></ng-template>
      </app-control-errors>
    </mat-error>
  </mat-form-field>
  <!-- Organization Preferences -->
  <dl class="preference-list">
    <dt>Organization Preferences</dt>
    <mat-form-field
      class="form-field col50 kh-no-padding homesick-days"
      appFormField
    >
      <mat-label>Default Homesick Days</mat-label>
      <input
        matInput
        type="number"
        min="0"
        formControlName="default_homesick_days"
      />
      <mat-error>
        <app-control-errors controlName="default_homesick_days">
          <ng-template appControlError="api" dynamicMessage></ng-template>
        </app-control-errors>
      </mat-error>
    </mat-form-field>
    <app-homesick-categories></app-homesick-categories>
    <dd>
      <mat-checkbox formControlName="discover_locations" class="checkbox">
        Automatically discover remote locations
      </mat-checkbox>
      <div class="checkbox-with-info">
        <mat-checkbox formControlName="any_fixed_is_home" class="checkbox">
          Treat all Vehicles, Trailers and Warehouses as home
        </mat-checkbox>
        <button
          mat-icon-button
          type="button"
          matTooltip="When unchecked, only home warehouses and the vehicles and trailers assigned to each as their home warehouse are treated as home."
          matTooltipPosition="after"
          aria-label="About treating vehicles, trailers, and warehouses as home"
          (click)="$event.preventDefault()"
        >
          <mat-icon>info</mat-icon>
        </button>
      </div>
    </dd>
  </dl>
  <!-- Form buttons -->
  <div class="form-buttons">
    <button mat-raised-button color="primary" [disabled]="pending">
      Submit
    </button>
    <a mat-button (click)="handleCancel()">Cancel</a>
  </div>
</form>
